import React, {useEffect, useState} from "react";
import {Sections} from "./video_comic_data";
import {Cursor, Images} from "../../AssetReferences";

import style from "./styles.module.css"
import {MicrobeBackButton} from "../../components/microbeBackButton";
import Enter from "./sections/enter";
import Gallery from "./sections/gallery";
import {useNavigate} from "react-router-dom";
import {PageTitles, SitePages} from "../../SitePages";
import {useTitle} from "../../hooks/UseTitle";

export default function MicrobialSexVideoComic({}) {
    const [section, setSection] = useState(Sections.Enter)
    const [videoGalleryReady, setVideoGalleryReady] = useState(false);
    const [enterVideoReady, setEnterVideoReady] = useState(false)
    const [galleryLoadProgress, setGalleryLoadProgress] = useState(0);

    const navigate = useNavigate();
    useTitle(PageTitles.MicrobialSexVideoComic)
    
    function Exit() {
        setSection(Sections.Enter)
        navigate(`../${SitePages.Home}`);
    }
   
    return (
        <>
            <div className={style.MicrobialSexVideoComic}>
                
                <MicrobeBackButton
                    className={style.backButton}
                    image_src={Images.ToiBig}
                    tooltip={"Click to return to homepage"}
                    size={5}
                    top={2}
                    left={2}
                    onClick={Exit}
                    cursorOnHover={Cursor.ToiCursorGlow}
                />

                {section === Sections.Enter
                    ? < Enter galleryLoaded={videoGalleryReady}
                              galleryLoadProgress={galleryLoadProgress}
                              onLoaded={() => setEnterVideoReady(true)} onEnterButtonPressed={() => setSection(Sections.Gallery)}/>
                    : null}
              

                {enterVideoReady 
                    ? <Gallery 
                        active={section === Sections.Gallery}
                        onLoading={setGalleryLoadProgress}
                        onIsReady={() => setVideoGalleryReady(true)}/>
                    : null
                }
                
                


            </div>
        </>
    )

}

